"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterByImpl = void 0;
var HttpError_1 = require("../model/HttpError");
var FilterByImpl = /** @class */ (function () {
    function FilterByImpl(config, contentClient) {
        this.config = config;
        this.contentClient = contentClient;
    }
    FilterByImpl.prototype.fetch = function (requestConfig) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var data, request_1, err_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        if (!((_a = requestConfig.parameters) === null || _a === void 0 ? void 0 : _a.locale) && ((_b = this.config) === null || _b === void 0 ? void 0 : _b.locale)) {
                            requestConfig.parameters = Object.assign({}, __assign(__assign({}, (requestConfig.parameters || {})), { locale: this.config.locale }));
                        }
                        return [4 /*yield*/, this.contentClient.post('content/filter', requestConfig)];
                    case 1:
                        data = (_c.sent()).data;
                        if (data.page.nextCursor) {
                            request_1 = Object.assign({}, __assign(__assign({}, requestConfig), { page: __assign(__assign({}, (requestConfig.page || {})), { cursor: data.page.nextCursor }) }));
                            data.page.next = function () { return _this.fetch(request_1); };
                        }
                        return [2 /*return*/, data];
                    case 2:
                        err_1 = _c.sent();
                        if (err_1.response) {
                            throw new HttpError_1.HttpError(err_1.response.status, err_1.response.data);
                        }
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FilterByImpl;
}());
exports.FilterByImpl = FilterByImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlsdGVyQnlJbXBsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9jb250ZW50L2Nvb3JkaW5hdG9ycy9GaWx0ZXJCeUltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFHQSxnREFBK0M7QUFFL0M7SUFDRSxzQkFDbUIsTUFBNkIsRUFDN0IsYUFBNEI7UUFENUIsV0FBTSxHQUFOLE1BQU0sQ0FBdUI7UUFDN0Isa0JBQWEsR0FBYixhQUFhLENBQWU7SUFDNUMsQ0FBQztJQUVFLDRCQUFLLEdBQVgsVUFBWSxhQUE4Qjs7Ozs7Ozs7O3dCQUV0QyxJQUFJLENBQUMsQ0FBQSxNQUFBLGFBQWEsQ0FBQyxVQUFVLDBDQUFFLE1BQU0sQ0FBQSxLQUFJLE1BQUEsSUFBSSxDQUFDLE1BQU0sMENBQUUsTUFBTSxDQUFBLEVBQUU7NEJBQzVELGFBQWEsQ0FBQyxVQUFVLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FDdEMsRUFBRSx3QkFFRyxDQUFDLGFBQWEsQ0FBQyxVQUFVLElBQUksRUFBRSxDQUFDLEtBQ25DLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLE1BQU0sSUFFN0IsQ0FBQzt5QkFDSDt3QkFFZ0IscUJBQU0sSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQzVDLGdCQUFnQixFQUNoQixhQUFhLENBQ2QsRUFBQTs7d0JBSE8sSUFBSSxHQUFLLENBQUEsU0FHaEIsQ0FBQSxLQUhXO3dCQUtaLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLEVBQUU7NEJBQ2xCLFlBQVUsTUFBTSxDQUFDLE1BQU0sQ0FDM0IsRUFBRSx3QkFFRyxhQUFhLEtBQ2hCLElBQUksd0JBQ0MsQ0FBQyxhQUFhLENBQUMsSUFBSSxJQUFJLEVBQUUsQ0FBQyxLQUM3QixNQUFNLEVBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLE9BR2pDLENBQUM7NEJBRUYsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLEdBQUcsY0FBTSxPQUFBLEtBQUksQ0FBQyxLQUFLLENBQUMsU0FBTyxDQUFDLEVBQW5CLENBQW1CLENBQUM7eUJBQzVDO3dCQUVELHNCQUFPLElBQUksRUFBQzs7O3dCQUVaLElBQUksS0FBRyxDQUFDLFFBQVEsRUFBRTs0QkFDaEIsTUFBTSxJQUFJLHFCQUFTLENBQUMsS0FBRyxDQUFDLFFBQVEsQ0FBQyxNQUFNLEVBQUUsS0FBRyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQzt5QkFDN0Q7d0JBRUQsTUFBTSxLQUFHLENBQUM7Ozs7O0tBRWI7SUFDSCxtQkFBQztBQUFELENBQUMsQUEvQ0QsSUErQ0M7QUEvQ1ksb0NBQVkifQ==